import styled from "@emotion/styled";
import {
  Select as SelectUnstyled,
  SelectProps as SelectUnstyledProps,
  Option as OptionUnstyled,
} from "@mui/base";
import { ArrowDropDown } from "@mui/icons-material";
import React from "react";

const StyledOption = styled(OptionUnstyled)`
  // needed for keyboard control highlighting, unfortunately
  &.MuiOptionUnstyled-highlighted {
    background-color: hsl(var(--color-primary-50));
  }
` as typeof OptionUnstyled;

const slotProps = {
  root: {
    className:
      "w-full border-0 bg-white rounded-md p-4 text-left hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-opacity-75 focus:bg-primary-50",
  },
  popper: { className: "w-72 z-[1300]" },
  listbox: {
    className:
      "w-72 shadow bg-white max-h-56 overflow-y-auto overflow-x-hidden",
  },
};

export type SelectOption<T> = {
  label: React.ReactNode;
  key: string;
  value: T;
};

type SelectMultiple = false;
export interface SelectProps<T extends {}>
  extends SelectUnstyledProps<T, SelectMultiple> {
  options: SelectOption<T>[];
  label?: string;
}

const Select = <T extends {}>(props: SelectProps<T>) => {
  const { options, label, ...selectUnstyledProps } = props;

  return (
    <div>
      {label && (
        <label className="subtitle mb-4 text-base font-semibold">
          {props.label}
        </label>
      )}
      <div className="relative rounded-md border border-solid border-primary-200 transition hover:border-primary hover:bg-primary-50">
        <SelectUnstyled
          defaultValue={options[0].value}
          slotProps={slotProps}
          {...selectUnstyledProps}
        >
          {props.options.map((option) => {
            return (
              <StyledOption
                className="w-72 cursor-pointer px-4 py-2 text-gray-700 hover:bg-primary-50 aria-selected:bg-primary-50"
                key={option.key}
                value={option.value}
              >
                {option.label}
              </StyledOption>
            );
          })}
        </SelectUnstyled>
        <div className="pointer-events-none absolute right-2 top-0 h-full">
          <div className="flex h-full items-center">
            <ArrowDropDown className="flex h-full items-center" />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Select };
